import { useSelector } from '../actions/types';
import * as selectors from '../selectors';
export function useCategoryPageData(categoryId) {
    const fetchingStatus = useSelector((state) => selectors.page.categoryPageFetchingStatus(state, categoryId));
    const category = useSelector((state) => selectors.categoryTree.category(state, categoryId));
    return {
        fetchingStatus,
        data: { category },
    };
}
//# sourceMappingURL=useCategoryPageData.js.map